import Vue from 'vue'
import VueCodemirror from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/twig/twig.js'
import 'codemirror/theme/ayu-dark.css'

Vue.use(VueCodemirror, {
  options: {
    theme: 'ayu-dark',
    mode: 'twig',
    indentUnit: 2,
    indentWithTab: false,
    lineNumbers: true,
    autofocus: true,
    tabSize: 2
  }
})
